/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'accounts': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M373.188 92.164c89.024 0 161.192 72.166 161.192 161.19 0 89.022-72.168 161.188-161.192 161.188-89.022 0-161.19-72.166-161.19-161.188 0-89.024 72.168-161.19 161.19-161.19zM50.192 931.836c0-259.96 144.61-470.702 322.992-470.702s322.992 210.74 322.992 470.702H50.192zm711.644-558.79c60.808 0 110.09 49.292 110.09 110.09 0 60.806-49.282 110.096-110.09 110.096-60.804 0-110.09-49.29-110.09-110.096 0-60.798 49.286-110.09 110.09-110.09zm211.972 558.79c0-170.606-94.906-308.908-211.98-308.908-18.07 0-35.622 3.296-52.376 9.502v-.016c46.078 81.37 73.758 185.686 73.758 299.422h190.598z"/>'
  }
})
